import React from 'react';
import moment from 'moment';
import { Column, Table } from '@tencent/spaui';
import { RPCFactory } from './../../../utils/RequestUtil';
import { NoticeDetail } from './noticeDetail';
import { menu } from './menu';

const columnRender = (type, name, value, data, showDialog, readNotice) => {
  let result = '';
  if (type !== 'head') {
    switch (name) {
      case 'title':
        result = (
          <a
            className="data-name-val a-link-hover dot-wrapper"
            href="javascript:;"
            onClick={(e) => {
              showDialog(data.noticeId);
              readNotice(data.noticeId, data.version);
            }}
          >
            {data.isRead ? <span className="base-dot gray" /> : <span className="base-dot blue" />}
            <span>{value}</span>
          </a>
        );
        break;
      case 'updateTime': {
        const date = moment(value).format('YYYY-MM-DD');
        result = <span>{date}</span>;
        break;
      }
      default:
        result = value;
        break;
    }
  } else {
    result = value;
  }
  return result;
};
export class NoticeTable extends React.PureComponent {
  constructor(props) {
    super(props);
    const isInMessagePage = location.hash.indexOf('message') != -1;
    // 获取noticeId, versionId, 如https://leads.qq.com/advertiser/20458#/message/index/575/1, noticeId为575， versionId为1
    const noticeRegObj = location.hash.match(/\d+/);
    const noticeArr = location.hash.match(/\d+/g);
    this.state = {
      value: '',
      list: [],
      show: isInMessagePage && /\d+/.test(location.hash), // 如果从外页面点击header的一条消息，需要显示消息
      clickedNoticeId: isInMessagePage && noticeRegObj ? noticeRegObj[0] : undefined,
    };
    this.hash = noticeRegObj ? location.hash.slice(0, noticeRegObj.index - 1) : location.hash; // 如果从外页面点击header的一条消息，需要跳转消息页面
    // 如果在message内部（constructor抓不到，需要新建url监听事件处理）点击header的某条消息，需要show消息，read消息
    this.listenToHash();
    if (isInMessagePage && noticeRegObj) {
      this.readNotice(noticeArr[0], noticeArr[1]);
    }
  }

  hashChangeHandler = () => {
    const isInMessagePage = location.hash.indexOf('message') != -1;
    const noticeId = location.hash.match(/\d+/g);
    if (isInMessagePage && noticeId) {
      this.setState({ show: true, clickedNoticeId: noticeId[0] });
      RPCFactory.noticeCenter.readNotice({
        noticeId: noticeId[0],
        version: noticeId[1],
      });
    }
  };

  listenToHash = () => {
    window.addEventListener('hashchange', this.hashChangeHandler);
  };

  getList = ({ isAll }) => {
    const { categoryId, startDate, endDate, pageSize, pageIndex } = this.props;
    RPCFactory.noticeCenter
      .getList({
        noticeStatus: this.props.noticeStatus,
        categoryId,
        startDate,
        endDate,
        ...(isAll ? { pageIndex: 1 } : { pageIndex }),
        ...(isAll ? {} : { pageSize }),
      })
      .done((data) => {
        this.setState({ list: data.entities });
        this.props.updateNoticeCount(data.size);
      });
  };

  readNotice = (noticeId, version) => {
    RPCFactory.noticeCenter.readNotice({
      noticeId,
      version,
    });
    const { list } = this.state;
    const item = list.find((item) => item.noticeId === noticeId);
    if (item) {
      item.isRead = true;
      this.setState({ list: [...list] });
    }
  };

  componentDidMount() {
    this.getList({ isAll: false });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.categoryId !== this.props.categoryId ||
      prevProps.startDate !== this.props.startDate ||
      prevProps.endDate !== this.props.endDate ||
      prevProps.pageIndex !== this.props.pageIndex ||
      prevProps.pageSize !== this.props.pageSize ||
      prevProps.noticeStatus !== this.props.noticeStatus
    ) {
      this.getList({ isAll: false });
    }
    if (prevProps.noticeStatus !== this.props.noticeStatus) {
      this.hash = menu.find((item) => item.key == this.props.noticeStatus).href;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.hashChangeHandler);
  }

  showDialog = (noticeId) => {
    this.setState({ show: true, clickedNoticeId: noticeId });
    location.hash = `${this.hash}/${noticeId}`;
  };

  hideDialog = () => {
    this.setState({ show: false });
    location.hash = this.hash;
  };

  render() {
    const { list, show, clickedNoticeId } = this.state;
    return (
      <div className="table-and-dialog">
        <Table data={list}>
          <Column
            name="title"
            maxWidth="350"
            render={(type, name, value, data) =>
              columnRender(type, name, value, data, this.showDialog, this.readNotice)
            }
          >
            标题
          </Column>
          <Column
            name="updateTime"
            maxWidth="100"
            render={(type, name, value, data) =>
              columnRender(type, name, value, data, this.showDialog, this.readNotice)
            }
          >
            日期
          </Column>
        </Table>
        {show && <NoticeDetail noticeId={clickedNoticeId} hideDialog={this.hideDialog} />}
      </div>
    );
  }
}
